import React from 'react';

const HealthCareIcon = () => {
  return (
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2010_378)">
        <path
          d="M23.8958 11.9167V19.5H15.2292V11.9167H14.1458V7.58338H16.3125V9.75005H18.4792V7.58338H20.6458V9.75005H22.8125V7.58338H24.9792V11.9167H23.8958ZM12.9542 4.77863L12.9032 4.8978L11.5783 7.58338H11.9792V9.75005H3.3125V7.58338H3.73608L2.35158 4.77863C2.24751 4.48425 2.21564 4.16919 2.25866 3.85994C2.30168 3.55068 2.41834 3.25628 2.59881 3.00149C2.77929 2.7467 3.01831 2.53898 3.29577 2.39578C3.57323 2.25259 3.88102 2.17812 4.19325 2.17863H6.57658V0.0119629H8.74325V2.17863H11.1266C11.4388 2.17812 11.7466 2.25259 12.0241 2.39578C12.3015 2.53898 12.5405 2.7467 12.721 3.00149C12.9015 3.25628 13.0182 3.55068 13.0612 3.85994C13.1042 4.16919 13.0723 4.48425 12.9683 4.77863H12.9542ZM15.2292 26H0.0625V24.9167C0.0625 24.0548 0.40491 23.2281 1.0144 22.6186C1.6239 22.0091 2.45055 21.6667 3.3125 21.6667H11.9792C12.8411 21.6667 13.6678 22.0091 14.2773 22.6186C14.8868 23.2281 15.2292 24.0548 15.2292 24.9167V26ZM4.16942 11.9167C3.81473 14.4834 3.26166 17.0188 2.51517 19.5H12.7776C12.0331 17.0183 11.4804 14.4831 11.1244 11.9167H4.16942ZM22.8125 21.6667H16.2843C17.0013 22.5988 17.3919 23.7408 17.3958 24.9167V26H26.0625V24.9167C26.0625 24.0548 25.7201 23.2281 25.1106 22.6186C24.5011 22.0091 23.6745 21.6667 22.8125 21.6667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2010_378">
          <rect width="26" height="26" fill="white" transform="translate(0.0625)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HealthCareIcon;
